export const removeAllSpace = (v?: string) => v?.replace(/\s/g, '');
